// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XObM","search":"Settings_search__2rf4L","filter":"Settings_filter__P4CsG"};